import React from "react";

import ReactHtmlParser from "react-html-parser";

const StrapiParser = (props) => {
  return <> {ReactHtmlParser(props.text)} </>
};

export default StrapiParser;
